import { LowerRegions } from "@/configs/region"

const imageRemoteUrlObj = {
  HeroLg: `${process.env.ASSETS_BASE_URL}/pay/customer-page/hero-lg.webp`,
  HeroMd: `${process.env.ASSETS_BASE_URL}/pay/customer-page/hero-md.webp`,
  HeroSm: `${process.env.ASSETS_BASE_URL}/pay/customer-page/hero-sm.webp`,
  HeroUKLg: `${process.env.ASSETS_BASE_URL}/pay/customer-page/hero-uk-lg.webp`,
  HeroUKMd: `${process.env.ASSETS_BASE_URL}/pay/customer-page/hero-uk-md.webp`,
  HeroUKSm: `${process.env.ASSETS_BASE_URL}/pay/customer-page/hero-uk-sm.webp`,
  HeroUSLg: `${process.env.ASSETS_BASE_URL}/pay/customer-page/hero-us-lg.webp`,
  HeroUSMd: `${process.env.ASSETS_BASE_URL}/pay/customer-page/hero-us-md.webp`,
  HeroUSSm: `${process.env.ASSETS_BASE_URL}/pay/customer-page/hero-us-sm.webp`,
  SendReceiveUIUK: `${process.env.ASSETS_BASE_URL}/pay/customer-page/send-receive-ui-uk.webp`,
  SendReceiveUI: `${process.env.ASSETS_BASE_URL}/pay/customer-page/send-receive-ui.webp`,
  SendReceiveNewUI: `${process.env.ASSETS_BASE_URL}/pay/customer-page/send-receive-ui-v1.webp`,
  SendPayMentUI: `${process.env.ASSETS_BASE_URL}/pay/customer-page/checkout/send-payment.webp`,
  SendPayMentNewUI: `${process.env.ASSETS_BASE_URL}/pay/customer-page/checkout/send-payment_v2.webp`,
}

export const getRegionConfig = (
  region: LowerRegions
): {
  isShowOneTimeCardSection: boolean
  heroSectionBackground: string[]
  SendReceiveImage: string
  SendPayMentUI: string
  newMerchantSection: { title: string; titleMaxWidth: any[] }
  beyondShopSection: { description: string }
  disclaimerSection: { disclaimer: string | null }
} => {
  const {
    HeroLg,
    HeroMd,
    HeroSm,
    HeroUKLg,
    HeroUKMd,
    HeroUKSm,
    HeroUSLg,
    HeroUSMd,
    HeroUSSm,
    SendReceiveUI,
    SendReceiveUIUK,
    SendReceiveNewUI,
    SendPayMentUI,
    SendPayMentNewUI,
  } = imageRemoteUrlObj

  const defaultConfig = {
    isShowOneTimeCardSection: false,
    heroSectionBackground: [HeroSm, HeroMd, HeroLg],
    SendReceiveImage: SendReceiveNewUI,
    SendPayMentUI: SendPayMentUI,
    newMerchantSection: {
      title: "newMerchant.title",
      titleMaxWidth: ["unset", 570, 840],
    },
    beyondShopSection: {
      description: "shopping.transfer_cash",
    },
    disclaimerSection: {
      disclaimer: "disclaimer.content",
    },
  }

  if (region === "us") {
    return {
      ...defaultConfig,
      isShowOneTimeCardSection: true,
      heroSectionBackground: [HeroUSSm, HeroUSMd, HeroUSLg],
      SendReceiveImage: SendReceiveUI,
      beyondShopSection: {
        description: "shopping.send_and_receive_description",
      },
      disclaimerSection: {
        disclaimer: null,
      },
    }
  }

  if (region === "uk") {
    return {
      ...defaultConfig,
      heroSectionBackground: [HeroUKSm, HeroUKMd, HeroUKLg],
      beyondShopSection: {
        description: "shopping.transfer_cash",
      },
      disclaimerSection: {
        disclaimer: "disclaimer.content_uk",
      },
    }
  }

  if (region === "ca") {
    return {
      ...defaultConfig,
      heroSectionBackground: [HeroUKSm, HeroUKMd, HeroUKLg],
      newMerchantSection: {
        title: "newMerchant.title_ca",
        titleMaxWidth: ["unset", 500, 800],
      },
    }
  }

  if (region === "eea") {
    return {
      ...defaultConfig,
      SendPayMentUI: SendPayMentNewUI,
      newMerchantSection: {
        title: "newMerchant.title_btc_eth_cro",
        titleMaxWidth: ["unset", 500, 800],
      },
    }
  }

  if (region === "au" || region === "sg") {
    return {
      ...defaultConfig,
      SendReceiveImage: SendReceiveUI,
      beyondShopSection: {
        description: "shopping.send_and_receive_description",
      },
      disclaimerSection: {
        disclaimer: null,
      },
    }
  }

  return defaultConfig
}
